import React from 'react'
import SearchIcon from '@mui/icons-material/Search';
import { SearchWrapper, SearchIconWrapper, StyledInputBase } from '../../StyledComponents'

function Search() {
	return (
		<SearchWrapper>
			<StyledInputBase
				placeholder="Search…"
				inputProps={{ 'aria-label': 'search' }}
			/>
			<SearchIconWrapper>
				<SearchIcon />
			</SearchIconWrapper>
		</SearchWrapper>
	)
}

export default Search
